import { MouseEvent, useRef, useState } from 'react';
import { useTranslation } from 'next-i18next';
import styles from '@components/SlideControl/SlideControl.styles';
import { IArrowPosition } from '@features/cms/typescript';
import { BASE_PATH } from '@config/index';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
type PropsType = {
  direction: 'next' | 'prev';
  onClick: (dir: 'next' | 'prev') => void;
  onMouseMove?: (e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>) => void;
  withScrollbar?: boolean;
};
const SlideControl = ({
  direction,
  onClick,
  onMouseMove = undefined,
  withScrollbar = false
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  const [mousePosition, setMousePosition] = useState<IArrowPosition>({
    top: 0,
    left: 0,
    isVisible: 0
  });
  const boxRef = useRef<HTMLButtonElement | null>(null);
  const handleMouseMove = (e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>) => {
    const boundingClientRect = boxRef.current?.getBoundingClientRect();
    if (!boundingClientRect) {
      setMousePosition({
        isVisible: 1,
        top: 0,
        left: 0
      });
      return;
    }
    const isInsideBox = boundingClientRect.left < e.clientX && e.clientX < boundingClientRect.right && e.clientY > boundingClientRect.top && e.clientY < boundingClientRect.bottom;
    setMousePosition({
      isVisible: isInsideBox ? 1 : 0,
      top: isInsideBox ? e.clientY - boundingClientRect.top : 0,
      left: isInsideBox ? e.clientX - boundingClientRect.left : 0
    });
    onMouseMove?.(e);
  };
  return <button type="button" sx={styles.slideControlField(direction, withScrollbar)} aria-label={t(direction === 'next' ? 'accessibility.nextSlide' : 'accessibility.previousSlide')} onClick={() => onClick(direction)} onMouseMoveCapture={e => handleMouseMove(e)} onMouseLeave={() => {
    setMousePosition({
      ...mousePosition,
      isVisible: 0
    });
  }} ref={boxRef}>
      <ResponsiveImage image={`${BASE_PATH}/icons/${direction}.svg`} width={40} height={100} sx={styles.arrowPosition(mousePosition)} alt="" />
    </button>;
};
export default SlideControl;